/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import TextArea from "@insite/mobius/TextArea/TextArea";
import { useWORContext } from "@tKgpco/Widgets/WOR/WORCheckoutReviewSubmitPage";
import * as React from "react";
import { useEffect, useState } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

const WOROrderNotes: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const { worData, worDispatch } = useWORContext();

    return (
        <GridContainer
            offsetCss={css`
                margin-bottom: 2.5rem;
                max-width: 100% !important;
            `}
        >
            <GridItem width={12}>
                <TextArea
                    value={worData?.orderNotes || ""}
                    onChange={e => worDispatch({ type: "SET_DATA", payload: { orderNotes: e.target.value } })}
                    label="Order Notes"
                    labelProps={{ size: 14 }}
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: WOROrderNotes,
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
